import styled, { css } from 'styled-components';
var ImageSrcsetContainer = styled.img.withConfig({
  displayName: "ImageSrcsetContainer",
  componentId: "sc-1ygu0kf-0"
})(["", ""], function (_ref) {
  var imageFluid = _ref.imageFluid;
  return imageFluid && css(["height:auto;max-width:100%;"]);
});
export default ImageSrcsetContainer;